import {Component, Input} from '@angular/core';
import {ActionMenuItem} from '../../models/action-menu-item.class';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-action-menu-item-2line',
  templateUrl: './action-menu-item-2line.component.html',
  styleUrls: ['./action-menu-item-2line.component.scss'],
  imports: [NgClass, MatIcon, MatMenuTrigger, MatIconButton, MatMenu, MatMenuItem],
})
export class ActionMenuItem2LineComponent {
  @Input() input: ActionMenuItem;
}
